import { useDispatch, useSelector } from 'react-redux'
import {
  RESET_INPUT_ADDRESS,
  SAVE_INPUT_ADDRESS,
  SAVE_PAYLOAD_ADDRESS,
  SAVE_SEARCH_ADDRESS,
} from '../redux/actions/address'
import {
  InputAddress,
  AddressStore,
  SearchAddress,
} from '../redux/reducers/addressReducer'
import { useCallback, useEffect } from 'react'

export function useAddress(
  addressType: 'billing' | 'shipping' = 'shipping',
  initInputAddress?: any,
  formatPayloadAddress?: any
): {
  address: AddressStore
  resetInputAddress
  saveSearchAddress: (searchAddress: SearchAddress) => void
  saveInputAddress: (inputAddress: InputAddress) => void
} {
  const dispatch = useDispatch()
  const address = useSelector((state) => state.inputAddress[addressType])
  const countries = useSelector((state) => state.parameters.countries)
  const currentAddress = useSelector((state) =>
    addressType === 'shipping'
      ? state.cart?.item?.shippingAddress
      : state.cart?.item?.billingAddress || state.user?.user?.address
  )

  const saveSearchAddress = useCallback(
    (searchAddress: SearchAddress) => {
      dispatch(SAVE_SEARCH_ADDRESS(searchAddress, addressType))
    },
    [addressType]
  )

  const saveInputAddress = useCallback(
    (inputAddress: InputAddress) => {
      dispatch(SAVE_INPUT_ADDRESS(inputAddress, true, addressType))
    },
    [addressType]
  )

  const resetInputAddress = useCallback(() => {
    dispatch(RESET_INPUT_ADDRESS(addressType))
  }, [addressType])

  useEffect(() => {
    if (initInputAddress) {
      const inputAdress = initInputAddress(currentAddress, countries)
      const isPanelOpen = Boolean(inputAdress.street)
      dispatch(SAVE_INPUT_ADDRESS(inputAdress, isPanelOpen, addressType))
    }
  }, [])

  useEffect(() => {
    if (address?.input && formatPayloadAddress) {
      const { payloadAddress, isValid } = formatPayloadAddress(
        address.input,
        countries
      )
      dispatch(SAVE_PAYLOAD_ADDRESS(isValid, payloadAddress, addressType))
    }
  }, [address?.input])

  return {
    address,
    resetInputAddress,
    saveSearchAddress,
    saveInputAddress,
  }
}
